/* eslint-disable react/no-unknown-property */
/* eslint-disable react/no-unused-prop-types */
/*
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2022 Scandiweb, Inc (https://scandiweb.com)
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Loader from 'Component/Loader';
import Popup from 'Component/Popup';
import { ProductType } from 'Type/ProductList.type';

import { SIZE_SELECTOR_POPUP_ID } from './SizeSelectorPopup.config';

import './SizeSelectorPopup.style';

/** @namespace Scandipwa/Component/SizeSelectorPopup/Component */
export class SizeSelectorPopupComponent extends PureComponent {
    renderOption = this.renderOption.bind(this);

    static propTypes = {
        showNotification: PropTypes.func.isRequired,
        hideActiveOverlay: PropTypes.func.isRequired,
        addProduct: PropTypes.func.isRequired,
        payload: PropTypes.shape({
            product: ProductType.isRequired,
            selectedColor: PropTypes.number.isRequired
        }).isRequired,
        onOptionClick: PropTypes.func.isRequired,
        isLoading: PropTypes.bool.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        options: PropTypes.array.isRequired,
        color_attribute_id: PropTypes.number,
        size_attribute_id: PropTypes.number,
        style_number: PropTypes.string
    };

    static defaultProps = {
        color_attribute_id: null,
        size_attribute_id: null,
        style_number: null
    };

    renderOptions() {
        const { options } = this.props;

        return (
            <div block="SizeSelectorPopup" elem="Options">
                { options.map((option) => this.renderOption(option)) }
            </div>
        );
    }

    renderOption(option) {
        const { onOptionClick } = this.props;

        return (
            <div
              aria-hidden="true"
              block="Button"
              elem="Primary"
              mods={ { color: 'white' } }
              // eslint-disable-next-line react/jsx-no-bind
              onClick={ () => onOptionClick(option) }
              // eslint-disable-next-line react/jsx-no-bind
              onKeyDown={ () => onOptionClick(option) }
            >
                { option.label }
            </div>
        );
    }

    render() {
        const {
            isLoading,
            style_number,
            payload: {
                product: {
                    id
                } = {}
            } = {}
        } = this.props;

        if (!id || !style_number) {
            return null;
        }

        return (
            <Popup
              id={ SIZE_SELECTOR_POPUP_ID }
              mix={ { block: 'SizeSelectorPopup' } }
            >
                <Loader isLoading={ isLoading } />
                { this.renderOptions() }
            </Popup>
        );
    }
}

export default SizeSelectorPopupComponent;
